import Tabs from './Tabs';

export default Tabs;
export type { ITabsProps } from './Tabs';
